import React, { useRef, useState } from 'react'
import "./Navbar.css"
import AnchorLink from "react-anchor-link-smooth-scroll"
const Navbar = () => {
  const [menu,setMenu]=useState("home")
  const menuRef=useRef()
  const openMenu=()=>{
menuRef.current.style.right="-10px"
  }
  const closeMenu=()=>{
menuRef.current.style.right = "-350px";
  }
  return (
    <div className="z-10 flex items-center py-6 justify-between bg-[#161513] bg-opacity-95 px-8 mb-5 md:px-14 lg:px-30 navbar fixed  top-0 left-0 right-0">
      <h1>FIRAOL</h1>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-8 h-8 mob-open"
        onClick={openMenu}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
        />
      </svg>
      <ul
        ref={menuRef}
        className="flex items-center gap-16 md:gap-8 lg:gap-12 text-xl md:text-base lg:text-lg xl:text-xl navbar-menu"
      >
        <p onClick={closeMenu} className="mob-close">
          x
        </p>

        <li
          className="cursor-pointer flex flex-col md:gap-1"
          onClick={() => {
            setMenu("home");
            closeMenu();
          }}
        >
          <AnchorLink className="anchor-link" href="#home">
            <p>Home</p>
            {menu === "home" ? <hr /> : <></>}
          </AnchorLink>
        </li>
        <li
          className="cursor-pointer flex flex-col md:gap-1"
          onClick={() => {
            setMenu("skills");
            closeMenu();
          }}
        >
          <AnchorLink className="anchor-link" offset={50} href="#skills">
            <p>Skills</p>
            {menu === "skills" ? <hr /> : <></>}
          </AnchorLink>
        </li>
        <li
          className="cursor-pointer flex flex-col md:gap-1"
          onClick={() => {
            setMenu("resume");
            closeMenu();
          }}
        >
          <AnchorLink className="anchor-link" offset={50} href="#resume">
            <p>Resume</p>
            {menu === "resume" ? <hr /> : <></>}
          </AnchorLink>
        </li>
        <li
          className="cursor-pointer flex flex-col md:gap-1"
          onClick={() => {
            setMenu("work");
            closeMenu();
          }}
        >
          <AnchorLink className="anchor-link" offset={50} href="#work">
            <p>Portifolio</p>
            {menu === "work" ? <hr /> : <></>}
          </AnchorLink>
        </li>
        <li
          className="cursor-pointer flex flex-col md:gap-1 md:hidden"
        onClick={() => {
          setMenu("contact");
          closeMenu();
        }}
      >
        <AnchorLink className="anchor-link" offset={50} href="#contact">
          <h1>Contact Me</h1>
        </AnchorLink>
     </li>
     </ul>
      <div
        className="text-black bg-white rounded-2xl items-center px-10 py-2 text-base lg:text-xl contact-me"
        onClick={() => {
          setMenu("contact");
          closeMenu();
        }}
      >
        <AnchorLink className="anchor-link" offset={50} href="#contact">
          <h1>Contact Me</h1>
        </AnchorLink>
      </div>
    </div>
  );
}

export default Navbar
